<template>
  <div id="app" class="row vert-offset-top-2">
    <div class="col s12 justify-content-center">
      <div class="col s12 m10 l7 offset-m1 offset-l2">
        <div id="card" class="card col s12 vert-offset-top-1  z-depth-3 ">
          <div
            class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
          >
            <h6 class=" vert-offset-top-1">
              Select one Tebelopele Facility you would like to visit
            </h6>
          </div>
          <div class="card-content col s12">
            <!--<div class="row" v-if="(selected_district !== null)">
              <div class="col s12 vert-offset-top-1"  >
                <custom-select-component :options="locations" title="Select Location" v-model="selected_location_key"  ref="obj_select_location"></custom-select-component>
              </div>
            </div>-->
            <div class="row">
              <div class="col s12 vert-offset-top-1">
                <custom-select-component
                  :options="centers"
                  title="Select Center"
                  v-model="selected_center_key"
                  ref="obj_select_center"
                ></custom-select-component>
              </div>
            </div>

            <div
              class="col s12 padding-bottom-half vert-offset-top-2 grey-border border-top-1 border-lighten-3 padding-top-1"
            >
              <transition name="custom-classes-transition"> </transition>
              <div class="col s6 m4 padding-bottom-1 padding-top-1 ">
                <button
                        type="submit"
                        @click="goback"
                        class="btn btn-small orange darken-1  white-text col s12"
                >
                  back
                </button>
              </div>
              <div class="col s6 m4 padding-bottom-1 padding-top-1 offset-m4">
              <button
                type="submit"
                @click="goto"
                class="btn btn-small orange darken-1  white-text col s12"
                :disabled="selected_center === null"
              >
                continue
              </button>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../http-common";
import { mapState } from "vuex";
import CustomSelectComponent from "../components/materiallize/CustomSelectComponent";
export default {
  name: "SelectAssementCenter",
  components: {
    CustomSelectComponent
  },
  data() {
    return {
      show: true,
      counter: 0,
      selected_district_new: null,
      countries: "BW",
      districts: [],
      locations: [],
      centers: [],
      selected_country: "BW",
      selected_country_key: "BW",
      selected_district: null,
      selected_district_key: "",
      selected_location: null,
      selected_location_key: "",
      selected_center: null,
      selected_center_key: ""
    };
  },
  methods: {
    goto() {
      this.$store.dispatch("START_PROCESSING");

      this.$store.dispatch("SET_SELECTED_CENTER", this.selected_center);
      /* this.$store.dispatch('SET_SELECTED_LOCATION', this.selected_location);
      this.$store.dispatch('SET_SELECTED_DISTRICT', this.selected_district);*/
      this.$router.push("/schedule");
      this.$store.dispatch("STOP_PROCESSING");
    },
    goback() {
      this.$router.push("/");
    },
    getCenterslist: function() {
      this.$store.dispatch("START_PROCESSING");
      this.selected_center;
      return new Promise(resolve => {
        http({
          url: "api/list",
          data: {
            district: this.selected_district_key,
            location: this.selected_location_key
          },
          method: "POST",
          timeout: 30000
        })
          .then(response => {
            console.log("centers:" + JSON.stringify(response.data));
            this.$store.dispatch("STOP_PROCESSING");
            this.centers = response.data.data;
            if (this.stateHasSelectedCenter) {
              this.selected_center_key = this.stateSelectedCenter.value;
            }
            resolve(response);
          })
          .catch(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", response.data.message);
            resolve(response);
          });
      });
    },
    getLocation: function() {
      this.$store.dispatch("START_PROCESSING");
      return new Promise(resolve => {
        http({
          url: "api/list/location",
          data: {
            country: this.countries,
            district: this.selected_district_key
          },
          method: "POST",
          timeout: 30000
        })
          .then(_response => {
            this.locations = _response.data.data;

            if (this.stateHasSelectedLocation) {
              this.selected_location_key = this.stateSelectedLocation.value;
            }
            this.$store.dispatch("STOP_PROCESSING");
            resolve(_response);
          })
          .catch(_response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", _response.data.message);
            resolve(_response);
          });
      });
    },
    getDistricts: function() {
      this.$store.dispatch("START_PROCESSING");
      return new Promise(resolve => {
        http({
          url: "api/list/district",
          data: {
            country: this.countries
          },
          method: "POST",
          timeout: 30000
        })
          .then(_response => {
            this.districts = _response.data.data;
            if (this.stateHasSelectedDistrict) {
              this.selected_district_key = this.stateSelectedDistrict.value;
            }

            this.$store.dispatch("STOP_PROCESSING");
            resolve(_response);
          })
          .catch(_response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", _response.data.message);
            resolve(_response);
          });
      });
    }
  },
  created() {
    this.getCenterslist();
  },
  computed: {
    ...mapState({
      stateSelectedDistrict: state => state.selectedDistrict,
      stateSelectedCenter: state => state.selectedCenter,
      stateSelectedLocation: state => state.selectedLocation
    }),
    prefs: function() {
      var d = {
        storedDistrict: this.districts,
        storedLocation: this.location
      };
      localStorage.setItem("myInput", JSON.stringify(d));
      return d;
    },
    stateHasSelectedDistrict: function() {
      return (
        typeof this.stateSelectedDistrict !== "undefined" &&
        this.stateSelectedDistrict !== null
      );
    },
    stateHasSelectedLocation: function() {
      return (
        typeof this.stateSelectedLocation !== "undefined" &&
        this.stateSelectedLocation !== null
      );
    },
    stateHasSelectedCenter: function() {
      return (
        typeof this.stateSelectedCenter !== "undefined" &&
        this.stateSelectedCenter !== null
      );
    }
  },
  mounted() {
    if (localStorage.districts) {
      this.districts = JSON.parse(localStorage.districts);
    }
  },
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
  watch: {
    selected_district_key: function(_value) {
      this.selected_location = null;
      this.selected_center_key = null;
      this.selected_district = null;
      if (typeof _value !== "undefined" && _value !== null) {
        var _arrFound = this.districts.filter(function(_item) {
          return _item.value == _value;
        });
        if (_arrFound.length > 0) {
          this.selected_district = _arrFound[0];
          this.getLocation();
          this.getCenterslist();
        }
      }
    },
    selected_location_key: function(_value) {
      if (typeof _value !== "undefined" && _value !== null) {
        var _arrFound = this.locations.filter(function(_item) {
          return _item.value == _value;
        });
        if (_arrFound.length > 0) {
          this.selected_location = _arrFound[0];
          this.getCenterslist();
        }
      }
    },
    selected_center_key: function(_value) {
      if (typeof _value !== "undefined" && _value !== null) {
        var _arrFound = this.centers.filter(function(_item) {
          return _item.value == _value;
        });
        if (_arrFound.length > 0) {
          this.selected_center = _arrFound[0];
        }
      }
    },
    districts(newDistricts) {
      localStorage.districts = JSON.stringify(newDistricts);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-kerning: normal;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
